import { CLOUD, loggedIn, sbRefresh, sbUrl } from './api.js';
import { cloudCheck } from './sync.js';
import { t } from '../i18n/index.js';
import { S } from '../state.js';
import { IC, closeSheet, esc, render, sheet, toast } from '../ui.js';

/* ---------- what the current plan allows ---------- */
export const ctx=()=>CLOUD.ctx||null;
export const plan=()=>(ctx()&&ctx().plan)||'pro';          // offline / not signed in: don't block
export const limits=()=>(ctx()&&ctx().limits)||{students:null,invoices:true,seats:null};
export const isFree=()=>plan()==='free';
export const trialDaysLeft=()=>{const c=ctx();if(!c||c.status!=='trialing'||!c.trial_ends_at)return null;
  return Math.max(0,Math.ceil((new Date(c.trial_ends_at)-Date.now())/86400000))};

export function canAddStudent(){
  const max=limits().students;if(max==null)return true;
  return S.students.filter(s=>!s.archived).length<max;
}
export const invoicesThisMonth=()=>{const m=new Date().toISOString().slice(0,7);return S.invoices.filter(i=>(i.issue||'').slice(0,7)===m&&!i.isStorno).length};
export function canInvoice(){const l=limits().invoices;if(l===false)return false;if(typeof l==='number')return invoicesThisMonth()<l;return true}

/* ---------- Stripe calls (Supabase edge functions) ---------- */
async function fn(name,body){
  if(Date.now()>CLOUD.auth.exp)await sbRefresh();
  const r=await fetch(sbUrl('/functions/v1/'+name),{method:'POST',
    headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+CLOUD.auth.at,'Content-Type':'application/json'},
    body:JSON.stringify({org:CLOUD.org,...(body||{})})});
  const d=await r.json().catch(()=>({}));
  if(!r.ok||!d.url)throw new Error(d.error||d.message||('HTTP '+r.status));
  return d.url;
}
export async function startCheckout(planName,interval,seats){
  toast(t('plan.redirect'));
  if(!loggedIn()){toast(t('plan.signin'));return}
  try{location.href=await fn('billing/checkout',{plan:planName,interval,seats,return_url:location.origin+location.pathname})}
  catch(e){console.error(e);toast(/404|not found|price not configured|STRIPE_SECRET_KEY/i.test(e.message)?t('plan.soon'):t('plan.err')+' ('+String(e.message||e).slice(0,120)+')')}
}
export async function openPortal(){
  try{location.href=await fn('billing/portal',{return_url:location.origin+location.pathname})}
  catch(e){console.error(e);toast(t('plan.err'))}
}
/* After Stripe redirects back, the webhook may lag a second or two. */
export function handleCheckoutReturn(){
  const q=new URLSearchParams(location.search);
  if(q.has('upgrade')){try{history.replaceState(null,'','/')}catch(e){}setTimeout(()=>openUpgrade(),600);return}
  const r=q.get('checkout');if(!r)return;
  if(q.get('addon')){import('./addons.js').then(m=>{if(!m.handleAddonReturn())try{history.replaceState(null,'',location.pathname)}catch(e){}});return}
  try{history.replaceState(null,'',location.pathname)}catch(e){}
  if(r==='success'){welcomePro();let n=0;const tick=async()=>{await cloudCheck();if(++n<5&&isFree())setTimeout(tick,2000)};setTimeout(tick,1500)}
}
/* "Willkommen bei Pro" after a successful payment */
function welcomePro(){
  const b=sheet(`<div class="sheetbody prowelcome">
    <div class="pw-badge">${IC.bolt}</div>
    <h2>${t('pro.welcome')}</h2><p class="muted">${t('pro.welcomeText')}</p>
    <ul class="checklist">${['plan.f1','plan.f2','plan.f3','plan.f4'].map(k=>'<li>'+t(k)+'</li>').join('')}</ul>
  </div><div class="sheetfoot"><div class="left"></div><button class="btn primary" data-a="ok">${t('pro.go')}</button></div>`);
  b.querySelector('[data-a=ok]').onclick=()=>closeSheet(b);
}
/* trial status where pro apps show it: bottom of the sidebar, and on the overview on phones */
export function trialInfo(){const d=trialDaysLeft();const c=ctx();if(d==null||!c||d>14||d<=0||(c.role&&c.role!=='owner'))return null;return {days:d,pct:Math.max(4,Math.min(100,Math.round((14-d)/14*100)))}}
export function updateTrialUI(){
  const slot=document.getElementById('trialslot');if(!slot)return;
  const i=trialInfo();
  if(!i){slot.innerHTML='';slot.hidden=true;return}
  slot.hidden=false;
  slot.innerHTML=`<div class="trialcard"><div class="tc-top"><b>${t('trial.title')}</b><span>${t(i.days===1?'trial.left1':'trial.left',{n:i.days})}</span></div>
    <div class="tc-bar"><span style="width:${i.pct}%"></span></div>
    <button class="btn small primary" data-trialup>${IC.bolt} ${t('trial.keep')}</button></div>`;
  slot.querySelector('[data-trialup]').onclick=()=>openUpgrade();
}
export function trialBanner(){
  const i=trialInfo();if(!i)return '';
  return `<div class="trialbanner"><span>${IC.bolt}</span><div class="grow"><b>${t(i.days===1?'trial.left1':'trial.left',{n:i.days})}</b><small>${t('trial.bannerSub')}</small></div><button class="btn small primary" data-trialup>${t('trial.keep')}</button></div>`;
}
/* the moment the trial is over: a clear choice instead of silently switching to Free */
export function maybeTrialEnded(){
  const c=ctx();if(!c||c.status!=='trialing'||!c.trial_ends_at||(c.role&&c.role!=='owner'))return;
  if(new Date(c.trial_ends_at)>new Date())return;
  S.settings.dismissed=S.settings.dismissed||{};
  if(S.settings.dismissed.trialEnded)return;
  const b=sheet(`<div class="sheethead"><h2>${t('trial.endTitle')}</h2></div>
  <div class="sheetbody">
    <p class="muted mb8">${t('trial.endText')}</p>
    <div class="endgrid">
      <div class="endcol"><h3>Free</h3><ul class="checklist"><li>${t('trial.free1')}</li><li>${t('trial.free2')}</li><li>${t('trial.free3')}</li></ul></div>
      <div class="endcol pro"><h3>Pro</h3><ul class="checklist"><li>${t('plan.f1')}</li><li>${t('plan.f2')}</li><li>${t('plan.f3')}</li></ul><p class="tiny">${t('trial.founder')}</p></div>
    </div>
  </div>
  <div class="sheetfoot"><button class="btn" data-a="free">${t('trial.stayFree')}</button><button class="btn primary" data-a="pro">${IC.bolt} ${t('trial.keep')}</button></div>`);
  const done=()=>{S.settings.dismissed.trialEnded=true;import('../state.js').then(m=>m.persist())};
  b.querySelector('[data-a=free]').onclick=()=>{done();closeSheet(b)};
  b.querySelector('[data-a=pro]').onclick=()=>{done();closeSheet(b);openUpgrade()};
}

/* ---------- UI ---------- */
export function openUpgrade(reason){
  const c=ctx();
  if(c&&c.role&&c.role!=='owner'){toast((reason?reason+' ':'')+t('plan.ownerOnly'));return}
  import('./plans.js').then(m=>m.openPlans({reason}));
}
export function planCard(){
  if(!loggedIn()||!ctx())return '';
  const c=ctx();const p=plan();const days=trialDaysLeft();
  const team=['team','team_plus','enterprise'].includes(p);
  const name=team?t('team.planTeam',{n:c.seats||1}):p==='free'?t('plan.free'):'Plume Pro';
  let line='';
  if(c.status==='trialing'&&days!=null)line=t('plan.trial',{n:days});
  else if(c.status==='active'&&c.current_period_end)line=t('plan.renews',{d:new Date(c.current_period_end).toLocaleDateString()});
  else if(c.status==='active')line=t('plan.unlimited');
  else if(c.status==='past_due')line='<span style="color:var(--danger)">'+t('plan.pastDue')+'</span>';
  else if(p==='free')line=t('plan.freeHint',{n:limits().students});
  const boss=!c.role||c.role==='owner';               // billing stays with the school's owner
  if(!boss)line+=(line?' ':'')+t('plan.byOwner');
  const btns=[];
  if(boss&&c.has_stripe)btns.push('<button class="btn small" data-pl="portal">'+t('plan.manage')+'</button>');
  if(boss&&(p==='free'||c.status==='trialing'))btns.push('<button class="btn small primary" data-pl="up">'+IC.bolt+' '+t('plans.title')+'</button>');
  return '<div class="card plancard"><div class="setrow"><span class="planic'+(p==='free'?' free':'')+'">'+IC.bolt+'</span><div class="grow"><b>'+esc(name)+'</b><small>'+line+'</small></div>'+
    (btns.length?'<div class="planbtns">'+btns.join('')+'</div>':'')+'</div></div>';
}
export function planAction(a){
  if(a==='up')openUpgrade();
  else if(a==='portal')openPortal();
}
export function refreshPlanUI(){try{render()}catch(e){}}
